import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { checkToken } from './interceptor.service';
import { of } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class AlliedservicesService {
  private adminToken: string | null;
  private urlLocal: string =
    environment.apiRoot || 'https://alternadevelop.com/api/v1/';

  private urlProd: string = environment.apiRoot;
  private apiBase: string = (environment.apiRoot || 'https://alternadevelop.com/api/v1/').replace(/\/+$/, '');
  public nameOrganization = new BehaviorSubject<string>('');
  public shareName = this.nameOrganization.asObservable();
  constructor(private http: HttpClient) {}

  //downloadTemplate file
  getLineaBaseFileTemplate() {
    return this.http.get(
      `${this.urlProd}allied/download-template`,
      { responseType: 'blob', context: checkToken() }
    );
  }

  //saveFiles
  uploadImportFile(alliedId: any, file: any, query?: string) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http
      .post(
        `${this.urlProd}allied/linea-base-import?id_allied=${alliedId}`,
        formData,
        { context: checkToken() }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  getAllAlliedProgressSheet(allied_id: string | null): Observable<Blob> {
    return this.http.get(
      `${this.urlLocal}statistics/generate-all-csv?id_allied=${allied_id}`,
      {
        responseType: 'blob',
        context: checkToken(),
      }
    );
  }

  getAllCompaniesTimeAppSheet(allied_id: string[], start_date: string, end_date: string) {
    const body = {
      allieds_ids: allied_id,
      start_date: start_date,
      end_date: end_date
    };
  
    return this.http.post<Blob>(
      `${this.urlLocal}statistics/generate-app-time`,
      body,
      {
        responseType: 'blob' as 'json',
        context: checkToken(),
      }
    );
  }

  private _refresrequired = new Subject<void>();
  get Refreshrequired() {
    return this._refresrequired;
  }

  private organizationPage: number = 2;
  public loading: boolean = false;

  shareNameOrganization(name: string) {
    this.nameOrganization.next(name);
  }

  getOrganizationScrolling(search: string, page: number, limit: number) {
    if (this.loading) {
      return of([]);
    }
    this.loading = true;
    return this.http
      .get(`${this.urlLocal}allied/list-allied`, {
        params: {
          search,
          page: this.organizationPage,
          limit,
        },
        context: checkToken(),
      })
      .pipe(
        tap(() => {
          this.organizationPage++;
          this.loading = false;
        })
      );
  }

  getListOrganizations(search: string, page: number, limit: number) {
    return this.http.get(`${this.urlLocal}allied/list-allied`, {
      params: {
        search,
        page,
        limit,
      },
      context: checkToken(),
    });
  }

  getOrganizationById(idOrg: string) {
    return this.http.get(
      `${this.urlLocal}allied/detail-allied?id_allied=${idOrg}`,
      { context: checkToken() }
    );
  }

  getAlliedQrToken(alliedId: string) {
    return this.http.post<{ token?: string; url: string; expires_at?: string }>(
      `${this.urlProd}allied/qr-token`,
      { allied_id: alliedId },
      { context: checkToken() }
    );
  }

  createAllied(data: any) {
    return this.http
      .post(`${this.urlLocal}allied/add-allied`, data, {
        context: checkToken(),
      })
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  editAllied(id: string, data: any) {
    return this.http
      .put(`${this.urlLocal}allied/edit-allied/?id_allied=${id}`, data, {
        context: checkToken(),
      })
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }

  //general dashboard dat

  getMainDashboardDataByOrg(
    id?: string,
    year?: string,
    idFacilitator?: string,
    idAgency?: string,
  ): Observable<any> {
    let params = new HttpParams()
      .set('id_allied', id ?? '')
      .set('year', year ?? '');

    if (idFacilitator) {
      params = params.set('id_facilitator', idFacilitator);
    }

    if (idAgency) {
      params = params.set('id_agency', idAgency);
    }

    return this.http.get(
      `${this.apiBase}/allied/general-dashboard`,
      { params, context: checkToken() }
    );
  }

  getGeneralDashboardEnterpriseStatus(
    id?: string,
    year?: string,
    idFacilitator?: string,
    idAgency?: string,
  ): Observable<any> {
    let params = new HttpParams()
      .set('id_allied', id ?? '')
      .set('year', year ?? '');

    if (idFacilitator) {
      params = params.set('id_facilitator', idFacilitator);
    }

    if (idAgency) {
      params = params.set('id_agency', idAgency);
    }

    return this.http.get(
      `${this.apiBase}/allied/general-dashboard-enterprise-status`,
      { params, context: checkToken() }
    );
  }

  getAlliedProgressSummary(
    idAllied: string,
    idFacilitator?: string,
    idAgency?: string,
  ): Observable<any> {
    let params = new HttpParams().set('allied_id', idAllied ?? '');
    if (idFacilitator) {
      params = params.set('id_facilitator', idFacilitator);
    }
    if (idAgency) {
      params = params.set('id_agency', idAgency);
    }
    return this.http.get(`${this.apiBase}/reports/allied-progress-summary`, {
      params,
      context: checkToken(),
    });
  }

  getAgenciesByAllied(idAllied: string): Observable<any> {
    const params = new HttpParams().set('id_allied', idAllied ?? '');
    return this.http.get(`${this.apiBase}/groups-companies/agencies-by-allied`, {
      params,
      context: checkToken(),
    });
  }

  getFacilitatorsByAllied(idAllied: string): Observable<any> {
    const params = new HttpParams().set('id_allied', idAllied ?? '');
    return this.http.get(`${this.apiBase}/groups-companies/facilitators-by-allied`, {
      params,
      context: checkToken(),
    });
  }

  getRegisteredVsCultivatedMonthly(
    idAllied: string,
    year?: string,
    idFacilitator?: string,
    idAgency?: string,
  ): Observable<any> {
    let params = new HttpParams().set('id_allied', idAllied ?? '');
    if (year) {
      params = params.set('year', year);
    }
    if (idFacilitator) {
      params = params.set('id_facilitator', idFacilitator);
    }
    if (idAgency) {
      params = params.set('id_agency', idAgency);
    }
    return this.http.get(`${this.apiBase}/allied/registered-vs-cultivated-monthly`, {
      params,
      context: checkToken(),
    });
  }

  getCultivatedByAgency(
    idAllied: string,
    year?: string,
    idFacilitator?: string,
    idAgency?: string,
  ): Observable<any> {
    let params = new HttpParams().set('id_allied', idAllied ?? '');
    if (year) {
      params = params.set('year', year);
    }
    if (idFacilitator) {
      params = params.set('id_facilitator', idFacilitator);
    }
    if (idAgency) {
      params = params.set('id_agency', idAgency);
    }
    return this.http.get(`${this.apiBase}/allied/cultivated-by-agency`, {
      params,
      context: checkToken(),
    });
  }

  private buildAlliedParams(idAllied: string, year?: string, idFacilitator?: string, idAgency?: string): HttpParams {
    let params = new HttpParams().set('id_allied', idAllied ?? '');
    if (year) params = params.set('year', year);
    if (idFacilitator) params = params.set('id_facilitator', idFacilitator);
    if (idAgency) params = params.set('id_agency', idAgency);
    return params;
  }

  getRegisteredByGender(idAllied: string, year?: string, idFacilitator?: string, idAgency?: string): Observable<any> {
    return this.http.get(`${this.apiBase}/allied/registered-by-gender`, {
      params: this.buildAlliedParams(idAllied, year, idFacilitator, idAgency),
      context: checkToken(),
    });
  }

  getRegisteredByLocation(idAllied: string, year?: string, idFacilitator?: string, idAgency?: string): Observable<any> {
    return this.http.get(`${this.apiBase}/allied/registered-by-location`, {
      params: this.buildAlliedParams(idAllied, year, idFacilitator, idAgency),
      context: checkToken(),
    });
  }

  getCultivatedByGender(idAllied: string, year?: string, idFacilitator?: string, idAgency?: string): Observable<any> {
    return this.http.get(`${this.apiBase}/allied/cultivated-by-gender`, {
      params: this.buildAlliedParams(idAllied, year, idFacilitator, idAgency),
      context: checkToken(),
    });
  }

  getProgressByChallenge(idAllied: string, year?: string, idFacilitator?: string, idAgency?: string): Observable<any> {
    return this.http.get(`${this.apiBase}/allied/progress-by-challenge`, {
      params: this.buildAlliedParams(idAllied, year, idFacilitator, idAgency),
      context: checkToken(),
    });
  }

  getCultivatedByLocation(idAllied: string, year?: string, idFacilitator?: string, idAgency?: string): Observable<any> {
    return this.http.get(`${this.apiBase}/allied/cultivated-by-location`, {
      params: this.buildAlliedParams(idAllied, year, idFacilitator, idAgency),
      context: checkToken(),
    });
  }

  getFacilitatorsSummary(idAllied: string): Observable<any> {
    const params = new HttpParams().set('id_allied', idAllied ?? '');
    return this.http.get(`${this.apiBase}/allied/facilitators-summary`, {
      params,
      context: checkToken(),
    });
  }

   getGeneralDashboardAverageEmployees(id?: string, year?: string): Observable<any> {
    return this.http.get(
     `${this.urlLocal}/allied/general-dashboard-average-employees?id_allied=${id}&year=${year}`,
     { context: checkToken() }
    );
  }

   getGeneralDashboardMedian(id?: string, year?: string): Observable<any> {
    return this.http.get(
     `${this.urlLocal}/allied/general-dashboard-median?id_allied=${id}&year=${year}`,
     { context: checkToken() }
    );
  }

  getGeneralDashboardMonthlyIncome(id?: string, year?: string): Observable<any> {
    return this.http.get(
     `${this.urlLocal}/allied/general-dashboard-monthly-income?id_allied=${id}&year=${year}`,
     { context: checkToken() }
    );
  }

   getGeneralDashboardCompaniesFinancing(id?: string, year?: string): Observable<any> {
    return this.http.get(
     `${this.urlLocal}/allied/general-dashboard-companies-financing?id_allied=${id}&year=${year}`,
     { context: checkToken() }
    );
  }

   getGeneralDashboardImpactStats(id?: string, year?: string): Observable<any> {
    return this.http.get(
     `${this.urlLocal}/allied/general-dashboard-impact-stats?id_allied=${id}&year=${year}`,
     { context: checkToken() }
    );
  }

   getGeneralDashboardBusinessStagePercent(id?: string, year?: string): Observable<any> {
    return this.http.get(
     `${this.urlLocal}/allied/general-dashboard-business-stage-percent?id_allied=${id}&year=${year}`,
     { context: checkToken() }
    );
  }

   getGeneralDashboardCompanyRanking(id?: string, year?: string): Observable<any> {
    return this.http.get(
     `${this.urlLocal}/allied/general-dashboard-company-ranking?id_allied=${id}&year=${year}`,
     { context: checkToken() }
    );
  }

  //metrics

  dashboardAllData() {
    return this.http.get(`${this.urlLocal}/allied/allied-dashboard`, {
     context: checkToken(),
    });
  }

  dashboardDataByYear(id_allied: string, year: string) {
    return this.http
      .get(
        `${this.urlLocal}/allied/allied-dashboard?id_allied=${id_allied}&year=${year}`,
        {
          context: checkToken(),
        }
      )
      .pipe(
        tap(() => {
          this.Refreshrequired.next();
        })
      );
  }
}
